import type {ReactElement} from 'react';
import {Text, TextSize} from '@Components/text';
import {EventsCreateGA4Source, GA4EventName, GA4EventParamName} from '@Libraries/ga-events';
import {EVENT_PROMOTION_LINK_EMOJI, EVENT_WIZARD_URI} from './event-promotion-link.types';
import styles from './event-promotion-link.module.scss';

/** The "Create a free event" link in the top-right corner of the login page's ticketing promo; opens the event wizard. */
export function EventPromotionLink(): ReactElement {
  const trackEventPromotionLinkClick = (): void => {
    window.PMW.gtm.trackGA4CustomEvent(GA4EventName.EVENTS_CREATE_LOGIN_CLICK);
    window.PMW.gtm.trackGA4CustomEvent(GA4EventName.EVENTS_CREATE_CLICK, {[GA4EventParamName.SOURCE]: EventsCreateGA4Source.LOGIN_PAGE});
  };

  return (
    <a className={styles.eventPromotionLink} href={window.PMW.util.site_url(EVENT_WIZARD_URI)} onClick={trackEventPromotionLinkClick}>
      <Text val={window.i18next.t('pmwjs_create_a_free_event')} size={TextSize.MD} bold underline />
      <Text val={EVENT_PROMOTION_LINK_EMOJI} size={TextSize.MD} bold attributes={{'aria-hidden': 'true'}} />
    </a>
  );
}
